// utils/countryCodes.js
//
// Every country / territory with its international dialling code, for the
// phone-number country-code dropdown (ContactDetails.jsx).
//
// DATA SOURCE: generated from Google's libphonenumber metadata (via the
// libphonenumber-js package) with English country names from Unicode CLDR
// (Intl.DisplayNames). 245 entries. Regenerate rather than hand-edit
// if the numbering plan changes.
//
// NOTE ON "+1": all NANP countries (US, Canada, Jamaica, Bahamas, ...) share
// the calling code +1 — their area code is part of the phone number itself
// (e.g. +1 242 for the Bahamas), so they are listed as +1 like the standard.

export const COUNTRY_CODES = [
  { iso: "AF", name: "Afghanistan", dial: "+93" },
  { iso: "AX", name: "Åland Islands", dial: "+358" },
  { iso: "AL", name: "Albania", dial: "+355" },
  { iso: "DZ", name: "Algeria", dial: "+213" },
  { iso: "AS", name: "American Samoa", dial: "+1" },
  { iso: "AD", name: "Andorra", dial: "+376" },
  { iso: "AO", name: "Angola", dial: "+244" },
  { iso: "AI", name: "Anguilla", dial: "+1" },
  { iso: "AG", name: "Antigua & Barbuda", dial: "+1" },
  { iso: "AR", name: "Argentina", dial: "+54" },
  { iso: "AM", name: "Armenia", dial: "+374" },
  { iso: "AW", name: "Aruba", dial: "+297" },
  { iso: "AC", name: "Ascension Island", dial: "+247" },
  { iso: "AU", name: "Australia", dial: "+61" },
  { iso: "AT", name: "Austria", dial: "+43" },
  { iso: "AZ", name: "Azerbaijan", dial: "+994" },
  { iso: "BS", name: "Bahamas", dial: "+1" },
  { iso: "BH", name: "Bahrain", dial: "+973" },
  { iso: "BD", name: "Bangladesh", dial: "+880" },
  { iso: "BB", name: "Barbados", dial: "+1" },
  { iso: "BY", name: "Belarus", dial: "+375" },
  { iso: "BE", name: "Belgium", dial: "+32" },
  { iso: "BZ", name: "Belize", dial: "+501" },
  { iso: "BJ", name: "Benin", dial: "+229" },
  { iso: "BM", name: "Bermuda", dial: "+1" },
  { iso: "BT", name: "Bhutan", dial: "+975" },
  { iso: "BO", name: "Bolivia", dial: "+591" },
  { iso: "BA", name: "Bosnia & Herzegovina", dial: "+387" },
  { iso: "BW", name: "Botswana", dial: "+267" },
  { iso: "BR", name: "Brazil", dial: "+55" },
  { iso: "IO", name: "British Indian Ocean Territory", dial: "+246" },
  { iso: "VG", name: "British Virgin Islands", dial: "+1" },
  { iso: "BN", name: "Brunei", dial: "+673" },
  { iso: "BG", name: "Bulgaria", dial: "+359" },
  { iso: "BF", name: "Burkina Faso", dial: "+226" },
  { iso: "BI", name: "Burundi", dial: "+257" },
  { iso: "KH", name: "Cambodia", dial: "+855" },
  { iso: "CM", name: "Cameroon", dial: "+237" },
  { iso: "CA", name: "Canada", dial: "+1" },
  { iso: "CV", name: "Cape Verde", dial: "+238" },
  { iso: "BQ", name: "Caribbean Netherlands", dial: "+599" },
  { iso: "KY", name: "Cayman Islands", dial: "+1" },
  { iso: "CF", name: "Central African Republic", dial: "+236" },
  { iso: "TD", name: "Chad", dial: "+235" },
  { iso: "CL", name: "Chile", dial: "+56" },
  { iso: "CN", name: "China", dial: "+86" },
  { iso: "CX", name: "Christmas Island", dial: "+61" },
  { iso: "CC", name: "Cocos (Keeling) Islands", dial: "+61" },
  { iso: "CO", name: "Colombia", dial: "+57" },
  { iso: "KM", name: "Comoros", dial: "+269" },
  { iso: "CG", name: "Congo - Brazzaville", dial: "+242" },
  { iso: "CD", name: "Congo - Kinshasa", dial: "+243" },
  { iso: "CK", name: "Cook Islands", dial: "+682" },
  { iso: "CR", name: "Costa Rica", dial: "+506" },
  { iso: "CI", name: "Côte d’Ivoire", dial: "+225" },
  { iso: "HR", name: "Croatia", dial: "+385" },
  { iso: "CU", name: "Cuba", dial: "+53" },
  { iso: "CW", name: "Curaçao", dial: "+599" },
  { iso: "CY", name: "Cyprus", dial: "+357" },
  { iso: "CZ", name: "Czechia", dial: "+420" },
  { iso: "DK", name: "Denmark", dial: "+45" },
  { iso: "DJ", name: "Djibouti", dial: "+253" },
  { iso: "DM", name: "Dominica", dial: "+1" },
  { iso: "DO", name: "Dominican Republic", dial: "+1" },
  { iso: "EC", name: "Ecuador", dial: "+593" },
  { iso: "EG", name: "Egypt", dial: "+20" },
  { iso: "SV", name: "El Salvador", dial: "+503" },
  { iso: "GQ", name: "Equatorial Guinea", dial: "+240" },
  { iso: "ER", name: "Eritrea", dial: "+291" },
  { iso: "EE", name: "Estonia", dial: "+372" },
  { iso: "SZ", name: "Eswatini", dial: "+268" },
  { iso: "ET", name: "Ethiopia", dial: "+251" },
  { iso: "FK", name: "Falkland Islands", dial: "+500" },
  { iso: "FO", name: "Faroe Islands", dial: "+298" },
  { iso: "FJ", name: "Fiji", dial: "+679" },
  { iso: "FI", name: "Finland", dial: "+358" },
  { iso: "FR", name: "France", dial: "+33" },
  { iso: "GF", name: "French Guiana", dial: "+594" },
  { iso: "PF", name: "French Polynesia", dial: "+689" },
  { iso: "GA", name: "Gabon", dial: "+241" },
  { iso: "GM", name: "Gambia", dial: "+220" },
  { iso: "GE", name: "Georgia", dial: "+995" },
  { iso: "DE", name: "Germany", dial: "+49" },
  { iso: "GH", name: "Ghana", dial: "+233" },
  { iso: "GI", name: "Gibraltar", dial: "+350" },
  { iso: "GR", name: "Greece", dial: "+30" },
  { iso: "GL", name: "Greenland", dial: "+299" },
  { iso: "GD", name: "Grenada", dial: "+1" },
  { iso: "GP", name: "Guadeloupe", dial: "+590" },
  { iso: "GU", name: "Guam", dial: "+1" },
  { iso: "GT", name: "Guatemala", dial: "+502" },
  { iso: "GG", name: "Guernsey", dial: "+44" },
  { iso: "GN", name: "Guinea", dial: "+224" },
  { iso: "GW", name: "Guinea-Bissau", dial: "+245" },
  { iso: "GY", name: "Guyana", dial: "+592" },
  { iso: "HT", name: "Haiti", dial: "+509" },
  { iso: "HN", name: "Honduras", dial: "+504" },
  { iso: "HK", name: "Hong Kong SAR China", dial: "+852" },
  { iso: "HU", name: "Hungary", dial: "+36" },
  { iso: "IS", name: "Iceland", dial: "+354" },
  { iso: "IN", name: "India", dial: "+91" },
  { iso: "ID", name: "Indonesia", dial: "+62" },
  { iso: "IR", name: "Iran", dial: "+98" },
  { iso: "IQ", name: "Iraq", dial: "+964" },
  { iso: "IE", name: "Ireland", dial: "+353" },
  { iso: "IM", name: "Isle of Man", dial: "+44" },
  { iso: "IL", name: "Israel", dial: "+972" },
  { iso: "IT", name: "Italy", dial: "+39" },
  { iso: "JM", name: "Jamaica", dial: "+1" },
  { iso: "JP", name: "Japan", dial: "+81" },
  { iso: "JE", name: "Jersey", dial: "+44" },
  { iso: "JO", name: "Jordan", dial: "+962" },
  { iso: "KZ", name: "Kazakhstan", dial: "+7" },
  { iso: "KE", name: "Kenya", dial: "+254" },
  { iso: "KI", name: "Kiribati", dial: "+686" },
  { iso: "XK", name: "Kosovo", dial: "+383" },
  { iso: "KW", name: "Kuwait", dial: "+965" },
  { iso: "KG", name: "Kyrgyzstan", dial: "+996" },
  { iso: "LA", name: "Laos", dial: "+856" },
  { iso: "LV", name: "Latvia", dial: "+371" },
  { iso: "LB", name: "Lebanon", dial: "+961" },
  { iso: "LS", name: "Lesotho", dial: "+266" },
  { iso: "LR", name: "Liberia", dial: "+231" },
  { iso: "LY", name: "Libya", dial: "+218" },
  { iso: "LI", name: "Liechtenstein", dial: "+423" },
  { iso: "LT", name: "Lithuania", dial: "+370" },
  { iso: "LU", name: "Luxembourg", dial: "+352" },
  { iso: "MO", name: "Macao SAR China", dial: "+853" },
  { iso: "MG", name: "Madagascar", dial: "+261" },
  { iso: "MW", name: "Malawi", dial: "+265" },
  { iso: "MY", name: "Malaysia", dial: "+60" },
  { iso: "MV", name: "Maldives", dial: "+960" },
  { iso: "ML", name: "Mali", dial: "+223" },
  { iso: "MT", name: "Malta", dial: "+356" },
  { iso: "MH", name: "Marshall Islands", dial: "+692" },
  { iso: "MQ", name: "Martinique", dial: "+596" },
  { iso: "MR", name: "Mauritania", dial: "+222" },
  { iso: "MU", name: "Mauritius", dial: "+230" },
  { iso: "YT", name: "Mayotte", dial: "+262" },
  { iso: "MX", name: "Mexico", dial: "+52" },
  { iso: "FM", name: "Micronesia", dial: "+691" },
  { iso: "MD", name: "Moldova", dial: "+373" },
  { iso: "MC", name: "Monaco", dial: "+377" },
  { iso: "MN", name: "Mongolia", dial: "+976" },
  { iso: "ME", name: "Montenegro", dial: "+382" },
  { iso: "MS", name: "Montserrat", dial: "+1" },
  { iso: "MA", name: "Morocco", dial: "+212" },
  { iso: "MZ", name: "Mozambique", dial: "+258" },
  { iso: "MM", name: "Myanmar (Burma)", dial: "+95" },
  { iso: "NA", name: "Namibia", dial: "+264" },
  { iso: "NR", name: "Nauru", dial: "+674" },
  { iso: "NP", name: "Nepal", dial: "+977" },
  { iso: "NL", name: "Netherlands", dial: "+31" },
  { iso: "NC", name: "New Caledonia", dial: "+687" },
  { iso: "NZ", name: "New Zealand", dial: "+64" },
  { iso: "NI", name: "Nicaragua", dial: "+505" },
  { iso: "NE", name: "Niger", dial: "+227" },
  { iso: "NG", name: "Nigeria", dial: "+234" },
  { iso: "NU", name: "Niue", dial: "+683" },
  { iso: "NF", name: "Norfolk Island", dial: "+672" },
  { iso: "KP", name: "North Korea", dial: "+850" },
  { iso: "MK", name: "North Macedonia", dial: "+389" },
  { iso: "MP", name: "Northern Mariana Islands", dial: "+1" },
  { iso: "NO", name: "Norway", dial: "+47" },
  { iso: "OM", name: "Oman", dial: "+968" },
  { iso: "PK", name: "Pakistan", dial: "+92" },
  { iso: "PW", name: "Palau", dial: "+680" },
  { iso: "PS", name: "Palestinian Territories", dial: "+970" },
  { iso: "PA", name: "Panama", dial: "+507" },
  { iso: "PG", name: "Papua New Guinea", dial: "+675" },
  { iso: "PY", name: "Paraguay", dial: "+595" },
  { iso: "PE", name: "Peru", dial: "+51" },
  { iso: "PH", name: "Philippines", dial: "+63" },
  { iso: "PL", name: "Poland", dial: "+48" },
  { iso: "PT", name: "Portugal", dial: "+351" },
  { iso: "PR", name: "Puerto Rico", dial: "+1" },
  { iso: "QA", name: "Qatar", dial: "+974" },
  { iso: "RE", name: "Réunion", dial: "+262" },
  { iso: "RO", name: "Romania", dial: "+40" },
  { iso: "RU", name: "Russia", dial: "+7" },
  { iso: "RW", name: "Rwanda", dial: "+250" },
  { iso: "WS", name: "Samoa", dial: "+685" },
  { iso: "SM", name: "San Marino", dial: "+378" },
  { iso: "ST", name: "São Tomé & Príncipe", dial: "+239" },
  { iso: "SA", name: "Saudi Arabia", dial: "+966" },
  { iso: "SN", name: "Senegal", dial: "+221" },
  { iso: "RS", name: "Serbia", dial: "+381" },
  { iso: "SC", name: "Seychelles", dial: "+248" },
  { iso: "SL", name: "Sierra Leone", dial: "+232" },
  { iso: "SG", name: "Singapore", dial: "+65" },
  { iso: "SX", name: "Sint Maarten", dial: "+1" },
  { iso: "SK", name: "Slovakia", dial: "+421" },
  { iso: "SI", name: "Slovenia", dial: "+386" },
  { iso: "SB", name: "Solomon Islands", dial: "+677" },
  { iso: "SO", name: "Somalia", dial: "+252" },
  { iso: "ZA", name: "South Africa", dial: "+27" },
  { iso: "KR", name: "South Korea", dial: "+82" },
  { iso: "SS", name: "South Sudan", dial: "+211" },
  { iso: "ES", name: "Spain", dial: "+34" },
  { iso: "LK", name: "Sri Lanka", dial: "+94" },
  { iso: "BL", name: "St. Barthélemy", dial: "+590" },
  { iso: "SH", name: "St. Helena", dial: "+290" },
  { iso: "KN", name: "St. Kitts & Nevis", dial: "+1" },
  { iso: "LC", name: "St. Lucia", dial: "+1" },
  { iso: "MF", name: "St. Martin", dial: "+590" },
  { iso: "PM", name: "St. Pierre & Miquelon", dial: "+508" },
  { iso: "VC", name: "St. Vincent & Grenadines", dial: "+1" },
  { iso: "SD", name: "Sudan", dial: "+249" },
  { iso: "SR", name: "Suriname", dial: "+597" },
  { iso: "SJ", name: "Svalbard & Jan Mayen", dial: "+47" },
  { iso: "SE", name: "Sweden", dial: "+46" },
  { iso: "CH", name: "Switzerland", dial: "+41" },
  { iso: "SY", name: "Syria", dial: "+963" },
  { iso: "TW", name: "Taiwan", dial: "+886" },
  { iso: "TJ", name: "Tajikistan", dial: "+992" },
  { iso: "TZ", name: "Tanzania", dial: "+255" },
  { iso: "TH", name: "Thailand", dial: "+66" },
  { iso: "TL", name: "Timor-Leste", dial: "+670" },
  { iso: "TG", name: "Togo", dial: "+228" },
  { iso: "TK", name: "Tokelau", dial: "+690" },
  { iso: "TO", name: "Tonga", dial: "+676" },
  { iso: "TT", name: "Trinidad & Tobago", dial: "+1" },
  { iso: "TA", name: "Tristan da Cunha", dial: "+290" },
  { iso: "TN", name: "Tunisia", dial: "+216" },
  { iso: "TR", name: "Türkiye", dial: "+90" },
  { iso: "TM", name: "Turkmenistan", dial: "+993" },
  { iso: "TC", name: "Turks & Caicos Islands", dial: "+1" },
  { iso: "TV", name: "Tuvalu", dial: "+688" },
  { iso: "VI", name: "U.S. Virgin Islands", dial: "+1" },
  { iso: "UG", name: "Uganda", dial: "+256" },
  { iso: "UA", name: "Ukraine", dial: "+380" },
  { iso: "AE", name: "United Arab Emirates", dial: "+971" },
  { iso: "GB", name: "United Kingdom", dial: "+44" },
  { iso: "US", name: "United States", dial: "+1" },
  { iso: "UY", name: "Uruguay", dial: "+598" },
  { iso: "UZ", name: "Uzbekistan", dial: "+998" },
  { iso: "VU", name: "Vanuatu", dial: "+678" },
  { iso: "VA", name: "Vatican City", dial: "+39" },
  { iso: "VE", name: "Venezuela", dial: "+58" },
  { iso: "VN", name: "Vietnam", dial: "+84" },
  { iso: "WF", name: "Wallis & Futuna", dial: "+681" },
  { iso: "EH", name: "Western Sahara", dial: "+212" },
  { iso: "YE", name: "Yemen", dial: "+967" },
  { iso: "ZM", name: "Zambia", dial: "+260" },
  { iso: "ZW", name: "Zimbabwe", dial: "+263" },
];

// When a dial code is shared, which country to preselect if we can't tell.
const MAIN_ISO_BY_DIAL = {
  "+1": "US",
  "+7": "RU",
  "+39": "IT",
  "+44": "GB",
  "+47": "NO",
  "+61": "AU",
  "+212": "MA",
  "+262": "RE",
  "+290": "SH",
  "+358": "FI",
  "+590": "GP",
  "+599": "CW",
};

// A dial code is '+' followed by 1-3 digits (ITU E.164).
export function isValidDialCode(code) {
  return typeof code === 'string' && /^\+\d{1,3}$/.test(code);
}

export function findCountryByIso(iso) {
  return COUNTRY_CODES.find(c => c.iso === iso) || null;
}

// lower-case, strip accents/punctuation, '&' -> 'and' so "Bosnia & Herzegovina" == "Bosnia and Herzegovina"
function norm(s) {
  return String(s || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
}

// Names people actually type/store that differ from the official English name.
const ALIASES = {
  'usa': 'US', 'u s a': 'US', 'u s': 'US', 'united states of america': 'US', 'america': 'US',
  'uk': 'GB', 'u k': 'GB', 'great britain': 'GB', 'britain': 'GB', 'england': 'GB', 'scotland': 'GB', 'wales': 'GB', 'northern ireland': 'GB',
  'uae': 'AE', 'u a e': 'AE',
  'south korea': 'KR', 'korea': 'KR', 'republic of korea': 'KR', 'korea south': 'KR',
  'north korea': 'KP',
  'czech republic': 'CZ', 'turkey': 'TR', 'ivory coast': 'CI', 'burma': 'MM', 'holland': 'NL',
  'the netherlands': 'NL', 'swaziland': 'SZ', 'east timor': 'TL', 'macedonia': 'MK', 'palestine': 'PS',
  'hong kong': 'HK', 'macau': 'MO', 'russian federation': 'RU', 'vatican': 'VA', 'vatican city': 'VA',
  'democratic republic of the congo': 'CD', 'dr congo': 'CD', 'drc': 'CD', 'republic of the congo': 'CG',
  'the bahamas': 'BS', 'the gambia': 'GM',
};

const NAME_INDEX = (() => {
  const m = new Map();
  for (const c of COUNTRY_CODES) { m.set(norm(c.name), c.iso); m.set(norm(c.iso), c.iso); }
  for (const [alias, iso] of Object.entries(ALIASES)) m.set(alias, iso);
  return m;
})();

// "India" / "USA" / "United Kingdom" / "UK" -> the matching country entry, or null
export function findCountryByName(name) {
  const iso = NAME_INDEX.get(norm(name));
  return iso ? findCountryByIso(iso) : null;
}

// Dial code for a free-text country name ("India" -> "+91"), or '' if we can't tell.
export function dialForCountryName(name) {
  return findCountryByName(name)?.dial || '';
}

// Which dropdown row should be selected for a stored dial code?
//  - if the user's own country uses that code, that country wins (so a Canadian with "+1" sees Canada, not the US)
//  - otherwise the "main" country for that code
//  - no stored code -> the code of the user's own country, if we can tell
//  - otherwise '' (dropdown shows a "Code" placeholder)
export function pickCountryIso(dialCode, userCountryName) {
  const userCountry = findCountryByName(userCountryName);
  if (dialCode) {
    if (userCountry && userCountry.dial === dialCode) return userCountry.iso;
    if (MAIN_ISO_BY_DIAL[dialCode]) return MAIN_ISO_BY_DIAL[dialCode];
    return COUNTRY_CODES.find(c => c.dial === dialCode)?.iso || '';
  }
  return userCountry ? userCountry.iso : '';
}

// What to show on the profile page: "+91 8978787787".
// A number that already carries its own "+" is shown as-is (never double-prefixed).
// With no stored code we fall back to the code for the user's country; if we still can't tell,
// we show the bare number rather than guess a wrong prefix.
export function formatPhoneDisplay({ phone, phoneCountryCode, country }) {
  const number = String(phone || '').trim();
  if (!number) return '';
  if (number.startsWith('+')) return number;
  const code = phoneCountryCode || dialForCountryName(country);
  return code ? `${code} ${number}` : number;
}

// ---------------------------------------------------------------------------
// Phone-number helpers shared by signup, settings, appointments and the
// doctor dashboard.
// ---------------------------------------------------------------------------

// Realistic bounds for the part of the number AFTER the country code
// (ITU E.164 allows 15 digits in total, country code included).
export const NATIONAL_NUMBER_MIN_DIGITS = 6;
export const NATIONAL_NUMBER_MAX_DIGITS = 14;

// Number boxes take digits plus the separators people like to type.
// Letters and "+" are dropped — the dropdown owns the country code.
export function sanitizePhoneInput(value) {
  return String(value || '').replace(/[^\d\s\-()]/g, '');
}

export function isPlausibleNationalNumber(value) {
  const digits = String(value || '').replace(/\D/g, '').length;
  return digits >= NATIONAL_NUMBER_MIN_DIGITS && digits <= NATIONAL_NUMBER_MAX_DIGITS;
}

// Dial codes whose numbering plan has a "trunk 0" people type when dialling
// domestically (UK 07911 123456, India 098765 43210, Germany 0151 ...).
// That 0 must be DROPPED once the country code is added: +44 7911 123456,
// not +44 07911 123456. Generated from the same libphonenumber metadata;
// deliberately excludes codes with no trunk 0 (e.g. Italy +39, where a
// leading 0 is part of the number and must be kept).
const TRUNK_ZERO_DIALS = new Set(["+20","+27","+31","+32","+33","+40","+41","+43","+44","+46","+49","+51","+53","+54","+55","+57","+58","+60","+61","+62","+63","+64","+66","+81","+82","+84","+86","+90","+91","+92","+93","+94","+95","+98","+211","+212","+213","+218","+231","+232","+233","+234","+243","+249","+250","+251","+252","+254","+255","+256","+260","+261","+262","+263","+264","+265","+291","+353","+355","+358","+359","+370","+373","+374","+377","+380","+381","+382","+383","+385","+386","+387","+389","+421","+423","+508","+590","+591","+593","+594","+595","+596","+598","+686","+850","+855","+856","+880","+886","+961","+962","+963","+964","+966","+967","+970","+971","+972","+976","+977","+994","+995","+996"]);

const DIAL_CODES = new Set(COUNTRY_CODES.map(c => c.dial));

// Pasted "+91 98765 43210" -> { dial: '+91', national: '9876543210' }.
// Unambiguous because no country calling code is the start of another one
// (there is no +9 or +97 next to +91 / +971), so the first match is the right one.
// Returns null when the text doesn't start with "+" or has no known code.
export function splitInternationalNumber(value) {
  const raw = String(value || '').trim();
  if (!raw.startsWith('+')) return null;
  const digits = raw.replace(/\D/g, '');
  for (let len = 1; len <= 3; len++) {
    const dial = '+' + digits.slice(0, len);
    if (digits.length >= len && DIAL_CODES.has(dial)) return { dial, national: digits.slice(len) };
  }
  return null;
}

// One place that turns whatever was typed/pasted into the number box into
//   { phone, dial, iso }
// A pasted international number ("+44 7911 123456") also tells us the country
// code, so the dropdown can follow it (dial/iso are null when it was a plain number).
export function parsePhoneInput(rawValue, userCountryName) {
  const split = splitInternationalNumber(rawValue);
  if (!split) return { phone: sanitizePhoneInput(rawValue), dial: null, iso: null };
  return { phone: split.national, dial: split.dial, iso: pickCountryIso(split.dial, userCountryName) };
}

// The number to actually DIAL, e.g. toDialNumber('+44', '07911 123456') -> '+447911123456'.
//  - a number that already starts with "+" is used as-is
//  - no country code known -> just the digits, as stored (same as before this feature existed)
export function toDialNumber(dialCode, phone) {
  const raw = String(phone || '').trim();
  if (!raw) return '';
  if (raw.startsWith('+')) return '+' + raw.replace(/\D/g, '');
  let digits = raw.replace(/\D/g, '');
  if (!digits) return '';
  if (!dialCode) return digits;
  if (TRUNK_ZERO_DIALS.has(dialCode) && digits.startsWith('0') && digits.length > NATIONAL_NUMBER_MIN_DIGITS) {
    digits = digits.slice(1);
  }
  return dialCode + digits;
}